export default __webpack_public_path__ + "static/media/Girdle of Effulgent Devotion.9fb80d9f.jpg";